<template>
  <div>
    <header-page
      :namePage="$t('pagesTitles.mc')"
      :isSearchInput="true"
      :links="$store.state.headerLinks.mimkMcLinks"
      :height="222"
      @searchByAmoId="searchByAmoId"
      @openSalaryModal="openSalaryModal"
    />
    <div class="content">
      <ReportModals @changeLoader="changeLoader" ref="reportModal" />
      <MimkModal
        ref="mimkModal"
        :statusMasterClass="statusMasterClass"
        @clearParentsData="clearParentsData"
        @saveMcData="saveMcData"
      />
      <SalaryModal ref="salaryModal" :height="222" />
      <v-select
        v-if="userRole === 'admin'"
        class="select-mimk"
        :options="$store.state.user.mimkList"
        :placeholder="$t('mc.placeholders.selectMimkFromList')"
        :clearable="false"
        @input="setMimk"
      />
      <SearchPeriod @searchByDate="searchByDate" />
      <loader v-if="isLoad" />
      <TableCommon
        v-else
        ref="mcTable"
        :choisenMimkIdByAdmin="userId"
        :startedPeriod="startSearchDate"
        :finishedPeriod="finishSearchDate"
        :emptyTableTitleName="$t('mc.mimk.titleFinished')"
        :isFinished="true"
        :sizeColumn="sizeColumn"
        :propsTableData="finishedData"
        @callReportTypeModal="callReportTypeModal"
        @choiseTotal="choiseTotal"
      />
    </div>
  </div>
</template>

<script>
import SearchPeriod from "@/components/UI/DatePickerPeriod";
import ReportModals from "@/components/Mimk/Modals/Report";
import TableCommon from "@/components/Mimk/TableCommon";
import MimkModal from "@/components/Mimk/Modals/McModal";
import SalaryModal from "@/components/Mimk/Modals/SalaryModal";
import apiBooking from "@/api/master-classes/booking";
export default {
  data() {
    return {
      searchedMasterClasses: [],
      startSearchDate: "",
      finishSearchDate: "",
      searchedId: "",
      statusMasterClass: "",
      checkedMkId: "",
      isLoad: true,
      finishedData: [],
      sizeColumn: "1.5fr 16px 1fr 1fr 1fr",
    };
  },
  components: {
    SearchPeriod,
    TableCommon,
    MimkModal,
    ReportModals,
    SalaryModal,
  },
  async created() {
    try {
      this.$metrika.reachGoal("TCM_click_past_tc_tab");
    } catch (err) {
      console.log(err);
    }
    this.userId = this.$store.state.user.user.id;
    await this.getAllBookings();
  },
  computed: {
    userRole() {
      return this.$store.state.user.user.role;
    },
  },
  methods: {
    openSalaryModal() {
      this.$refs.salaryModal.openModal();
    },
    async changeLoader(boolean) {
      if (boolean) this.isLoad = boolean;
      else {
        await this.getAllBookings("loadingByPickerDate");
        this.$nextTick(() => (this.isLoad = boolean));
      }
    },
    callReportTypeModal(emitObj) {
      this.$refs.reportModal.callModal(
        emitObj.type,
        emitObj.reportMcModalFields,
        emitObj.element
      );
    },
    async setMimk(mimk) {
      this.userId = mimk.id;
      this.$store.commit("user/setAdminSharedMimkId", mimk.id);
      let loadByGotPickerDate = this.startSearchDate
        ? "loadingByPickerDate"
        : false;
      await this.getAllBookings(loadByGotPickerDate);
    },
    async searchByAmoId(searchedString) {
      this.isLoad = true;
      const role = this.$store.state.user.user.role;
      let mimkId =
        role === "admin"
          ? this.choisenMimkIdByAdmin
          : this.$store.state.user.user.id;
      this.searchedMasterClasses = await apiBooking.getMkByLink(
        searchedString,
        mimkId
      );
      if (!this.searchedMasterClasses) {
        this.isLoad = false;
      } else {
        this.finishedData = [...this.searchedMasterClasses.finished];
        this.isLoad = false;
      }
    },
    async searchByDate({ start, finish }) {
      this.isLoad = true;
      this.startSearchDate = start;
      this.finishSearchDate = finish;
      await this.getAllBookings("loadingByPickerDate");
      this.isLoad = false;
    },
    choiseTotal({ status, id }) {
      this.checkedMkId = id;
      this.statusMasterClass = status;
      this.isModalVisible = true;
      this.$refs.mimkModal.openModal();
    },
    async saveMcData(modalData) {
      const foundTask = this.finishedData.findIndex(
        (el) => el.id === this.checkedMkId
      );
      let task = this.finishedData[foundTask];
      this.isLoad = true;
      await apiBooking.addSuccessMkinfo(
        task.id,
        this.statusMasterClass,
        modalData
      );
      await this.getAllBookings("loadingByPickerDate");
      this.isLoad = false;
    },
    async getAllBookings(pickerDate) {
      this.isLoad = true;
      let firstDate = this.$dayjs(new Date()).format("YYYY-MM-DD") + " 00:00";
      let secondDate = this.$dayjs(new Date()).format("YYYY-MM-DD") + " 00:00";
      if (pickerDate) {
        firstDate =
          this.$dayjs(this.startSearchDate, "DD.MM.YYYY").format("YYYY-MM-DD") +
          " 00:00";
        secondDate =
          this.$dayjs(this.finishSearchDate, "DD.MM.YYYY").format(
            "YYYY-MM-DD"
          ) + " 00:00";
      }
      this.isLoad = true;
      const mkList = await apiBooking.getMimkBookings(
        firstDate,
        secondDate,
        this.userId
      );
      this.finishedData = [...mkList.finished];
      this.isLoad = false;
    },
    clearParentsData() {
      this.statusMasterClass = null;
      this.checkedMkId = null;
    },
  },
};
</script>
